export const EXCLUDED_EMAILS: ReadonlySet<string> = new Set([
  'ingakovalski@gmail.com',
  'ingakovalski1@gmail.com',
  'sergey.rubins@gmail.com',
  'sergey.a.bulychev@gmail.com',
  'pavel@raduke.com',
  'dima355@gmail.com',
  'n.rumjanceu@gmail.com',
  'bess.adw@gmail.com',
  'yelizaveta.ost@gmail.com',
  'rufus57@yandex.ru',
  'rufus57@gmail.com',
  '88adidas@gmail.com',
  'serg.kondrashov@gmail.com',
  'disart404@gmail.com',
  'greeny0909@gmail.com',
  'kirillduraley@gmail.com',
  'sazanavaleksandr@gmail.com',
  'cat.d022r@gmail.com',
]);

export const INTERNAL_EMAIL_DOMAINS: readonly string[] = ['@lumir.photo', '@lumir.cloud'];

/** `test` opening the local part or a `.`/`_`/`+`/`-` segment of it: `qa.tester@` matches, `contest@` does not. */
export const INTERNAL_EMAIL_TEST_TOKEN: RegExp = /(^|[._+-])test/;

/** Team account: listed address or company domain. No keyword match, so a real customer named «contest@…» passes. */
export function isTeamEmail(email: string | undefined | null, excludedEmails: ReadonlySet<string> = EXCLUDED_EMAILS): boolean {
  if (!email) return false;
  const normalized: string = email.toLowerCase();
  if (excludedEmails.has(normalized)) return true;
  return INTERNAL_EMAIL_DOMAINS.some((domain: string): boolean => normalized.endsWith(domain));
}

export function isInternalEmail(
  email: string | undefined | null,
  excludedEmails: ReadonlySet<string> = EXCLUDED_EMAILS,
): boolean {
  if (!email) return false;
  if (isTeamEmail(email, excludedEmails)) return true;
  return INTERNAL_EMAIL_TEST_TOKEN.test(email.toLowerCase().split('@')[0]);
}
